import RIOButton, { type BUTTON_SIZE, type BUTTON_STYLE, type BUTTON_VARIANT } from '@rio-cloud/rio-uikit/Button';
import classnames from 'classnames';
import type { PropsWithChildren } from 'react';

import type { PropsWithTestId } from '../types';

interface ButtonProps {
    onClick?: () => void;
    variant?: BUTTON_VARIANT;
    size?: BUTTON_SIZE;
    style?: BUTTON_STYLE;
    disabled?: boolean;
    className?: string;
    type?: 'button' | 'submit';
    dark?: boolean;
    fullWidth?: boolean;
    isLoading?: boolean;
}

/**
 * The Button component is used for actions and links in a page.
 * It's a wrapper around the Button component from rio-uikit
 */
const Button = ({
    onClick,
    variant,
    size,
    style,
    className,
    disabled,
    type,
    dark,
    fullWidth,
    isLoading,
    children,
    'data-testid': dataTestId,
}: PropsWithTestId<PropsWithChildren<ButtonProps>>) => (
    <RIOButton
        data-testid={dataTestId}
        onClick={onClick}
        variant={variant}
        bsSize={size}
        bsStyle={style}
        disabled={disabled || isLoading}
        className={classnames([
            className,
            {
                'border-none bg-gray-darker text-gray-light outline-none hover:bg-gray-darkest active:bg-black': dark,
            },
            {
                'h-fit width-100pct border-none py-25 shadow-top transition-all hover:shadow-none disabled:opacity-40':
                    fullWidth,
            },
        ])}
        type={type}
    >
        {isLoading && <span className='Button__spinner rioglyph rioglyph-spinner' />}
        {children}
    </RIOButton>
);

export default Button;
